<template lang="pug">
.member
  img(:src="$data[grade]")
  
</template>
<script>
import primary from '@/assets/icons/member/primary.png'
import golden from '@/assets/icons/member/gold.png'
import platinum from '@/assets/icons/member/platinum.png'
import diamond from '@/assets/icons/member/diamond.png'
export default {
  name: 'Member',
  props: {
    grade: {},
  },
  data() {
    return {
      primary: primary,
      golden: golden,
      platinum: platinum,
      diamond: diamond,
    }
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.member
  width: 100%
  height: 100%
  img
    width: 100%
    height: 100%
</style>
